import _objectWithoutPropertiesLoose from "@babel/runtime-corejs3/helpers/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
var _excluded = ["tag"];
import { Component, createVNode as h } from 'intact-vue';
var typeDefs = {
  tag: String
};
/**
 * A component only used in React or Vue to bind event, so that
 * it can use Intact Event system to stop propagation (stopPropagation).
 */
export var View = /*#__PURE__*/function (_Component) {
  _inheritsLoose(View, _Component);
  function View() {
    return _Component.apply(this, arguments) || this;
  }
  View.template = function template() {
    var _this$get = this.get(),
      tag = _this$get.tag,
      rest = _objectWithoutPropertiesLoose(_this$get, _excluded);
    return h(tag, rest);
  };
  View.defaults = function defaults() {
    return {
      tag: 'div'
    };
  };
  return View;
}(Component);
View.typeDefs = typeDefs;